import { Component, Output, EventEmitter } from '@angular/core'
import { ActionSheetController } from 'ionic-angular'
import { Input } from '@angular/core'

import { HousingUnit, User, UIStrings, Device, DeviceType } from '../../models/models'
import { AlertController, NavController, ToastController } from 'ionic-angular'
import { AuthProvider } from '../../providers/auth/auth'
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit'
import { HousingUnitEditPage } from '../../pages/housing-unit-edit/housing-unit-edit'
import { HousingUnitShowPage } from '../../pages/housing-unit-show/housing-unit-show'
import { SignalingSocketIoProvider } from '../../providers/signaling/socket_io'
import { ConfigProvider } from '../../providers/config/config'

//import { ConfigProvider } from '../../providers/config/config';


@Component({
	selector: 'housing-unit-item',
	templateUrl: 'housing-unit-item.html'
})
export class HousingUnitItemComponent {
	@Output() refresh: EventEmitter<HousingUnit> = new EventEmitter<HousingUnit>();

	@Input() public housingUnit: HousingUnit
	/**
	Eventuale utente di cui si visualizza l'unità abitativa
	*/
	@Input() public user: User

	/**
	Opzionale ruolo per il quale si sta visualizzando l'unità immobliare
	*/
	@Input() public role: string = null;
	/**
	Se true visualizza una riga di dettaglio
	*/
	@Input() public isDetailsVisible: boolean = false;
	/**
	Se false nasconde il menù
	*/
	@Input() public isMenuVisible: boolean = true;


	private _isShowable: boolean = null;
	/**
	Override esplicito visualizzabilità: se != null sovrascrive i permessi
	*/
	@Input() set isShowable(isShowable) {
		console.debug('[HousingUnitItemComponent.isShowable() set] Impostazione esplicita visualizzabilità: ' + (isShowable ? 'true' : 'false'))
		this._isShowable = isShowable
	}
	get isShowable(): boolean {
		if(this._isShowable !== null) {
			return this._isShowable
		}

		return this.auth.canHousingUnitShow(this.housingUnit)
	}

	get isEditable(): boolean {
		return this.auth.canHousingUnitEdit(this.housingUnit)
	}

	get isDeletable(): boolean {
		return this.auth.canHousingUnitDelete(this.housingUnit)
	}

	/**
Verifica se può aprire il portone
	*/
	get isOpenable(): boolean {
		let devices = this.housingUnit.condominium.devices
		for(let device of devices) {
			if(device.type == DeviceType.INTERCOM && device.identifier) {
				//gestori, proprietari e residenti, e addetti e amministratore del condominio
				return this.auth.canCondominiumOpen(this.housingUnit.condominium)
			}
		}
		return false
	}


	/*
	Controlla se l'utente corrente può rimuovere il ruolo da questa unità abitativa
	*/
	get isRemovable(): boolean {
		if(!this.role) {
			return false
		}
		//operatori, amministratore di condominio e proprietari solo per residenti
		if(this.auth.hasRole(['is_admin', 'is_operator'])) return true
		if(this.auth.hasCondominiumRole(this.housingUnit.condominium, 'is_administrator')) return true
		if(this.role == 'resident' && this.auth.hasHousingUnitRole(this.housingUnit, 'is_owner')) return true
		return false
	}

	private roles = {
		is_owner: 'Proprietario',
		is_resident: 'Residente',
	};

	constructor(
		public actionSheetCtrl: ActionSheetController,
		private alertCtrl: AlertController,
		public auth: AuthProvider,
		private nav: NavController,
		private toastCtrl: ToastController,
		private housingUnits: HousingUnitProvider,
		private signaling: SignalingSocketIoProvider
	) {
	}


	goToHousingUnitEdit() {
		this.nav.push(HousingUnitEditPage, { housingUnit: this.housingUnit })
	}

	public goToHousingUnitShow(event = null) {
		if(event) {
			event.stopPropagation()
		}

		if(!this.isShowable) {
			console.debug('[HousingUnitItemComponent.goToHousingUnitShow()] Non si hanno i permessi per visualizzare l\'unità abitativa')
			return
		}

		this.nav.push(HousingUnitShowPage, { housingUnit: this.housingUnit })
	}

	/**
	Invia un messaggio al citofono chiedendogli di aprire il portone
	*/
	public openDoorway() {
		//recupera tutti i dispositivi del condominio
		//per ogni dispositivo se citofono invia comando
		let devices: Device[] = this.housingUnit.condominium.devices
		let sent = false
		for(let device of devices) {
			if(device.type == DeviceType.INTERCOM && device.identifier) {
				console.debug('Invio la richiesta al citofono: ', device)
				let peerId = ConfigProvider.generatePeerIdDevice(device.identifier)
				this.signaling.sendOpenDoorway(peerId)
				sent = true
			}
		}


		let self = this
		if(sent) {
			let toast = self.toastCtrl.create({
				message: "Comando di apertura inviato",
				position: 'middle',
				duration: 3000,
				//cssClass: "light"
			})
			toast.present()
		} else {
			let toast = self.toastCtrl.create({
				message: "Errore configurazione: Nessun citofono trovato per aprire il portone",
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
		}
	}

	showDestroyHousingUnitConfirm() {
		let self = this
		let housingUnit = this.housingUnit

		let confirm = this.alertCtrl.create({
			title: "Eliminare l'unità immobliare dal server?",
			message: "Vuoi davvero eliminare l'unità abitativa " + housingUnit.internal + " '" + housingUnit.label + "'?",
			buttons: [
				{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel'
				}, {
					text: UIStrings.DELETE,
					handler: () => {
						self.housingUnits.destroy(housingUnit).then((success: boolean) => {
							if(success) {
								let toast = self.toastCtrl.create({
									message: 'Unità abitativa eliminata',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								})
								toast.present()
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando l'unità abitativa",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							}
							self.refresh.emit(housingUnit)
						}).catch(error => {
							console.error("Errore cancellando l'unità abitativa", error)
							let toast = self.toastCtrl.create({
								message: "Errore cancellando l'unità abitativa",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
							self.refresh.emit(housingUnit)
						})
					}
				}
			]
		})
		confirm.present()
	}

	/**
	Visualizza le note per il citofono
	*/
	public showNote(event) {
		if(event) {
			event.stopPropagation()
		}

		let alert = this.alertCtrl.create({
			title: 'Note per il citofono',
			subTitle: this.housingUnit.note ? this.housingUnit.note : '- NESSUNA -',
			buttons: [{
				text: UIStrings.DIALOG_OK,
				role: 'cancel',
				handler: () => {}
			}]
		})
		alert.present()
	}

	public showMenu(event) {
		if(event) {
			event.stopPropagation()
		}

		let self = this
		let buttons = []


		if(this.isOpenable) {
			buttons.push({
				text: UIStrings.DOORWAY_OPEN,
				icon: 'key',
				handler: () => {
					self.openDoorway()
				}
			})
		}

		if(this.isShowable) {
			buttons.push({
				text: UIStrings.SHOW,
				icon: 'eye',
				handler: () => {
					self.goToHousingUnitShow()
				}
			})
		}
		if(this.isEditable) {
			buttons.push({
				text: UIStrings.EDIT,
				role: 'destructive',
				icon: 'create',
				handler: () => {
					self.goToHousingUnitEdit()
				}
			})
		}
		if(this.isRemovable) {
			buttons.push({
				text: UIStrings.ROLE_REMOVE + ' ' + this.roles[this.role],
				role: 'destructive',
				icon: 'remove',
				handler: () => {
					self.showRemoveRoleConfirm()
				}
			})
		}
		if(this.isDeletable) {
			buttons.push({
				text: UIStrings.DELETE,
				role: 'destructive',
				icon: 'trash',
				handler: () => {
					self.showDestroyHousingUnitConfirm()
				}
			})
		}


		buttons.push({
			text: UIStrings.MENU_CLOSE,
			role: 'cancel',
			icon: 'undo',
			handler: () => {}
		})

		let title = 'Unità abitativa ' + this.housingUnit.label
		let subTitle = ''
		if(this.housingUnit.condominium) {
			if(this.housingUnit.condominium.name) {
				subTitle += this.housingUnit.condominium.name
			}
			if(this.housingUnit.condominium.address) {
				subTitle += ' ' + this.housingUnit.condominium.address.formatted
			}
		}
		if(this.housingUnit.stair) {
			subTitle += ' scala ' + this.housingUnit.stair
		}
		if(this.housingUnit.stair) {
			subTitle += ' piano ' + this.housingUnit.floor
		}
		if(this.housingUnit.stair) {
			subTitle += ' interno ' + this.housingUnit.internal
		}

		let options = {
			title: title,
			subTitle: subTitle,
			buttons: buttons
		}

		let actionSheet = this.actionSheetCtrl.create(options)
		actionSheet.present()
	}

	showRemoveRoleConfirm() {
		let self = this
		let housingUnit = this.housingUnit
		let role = this.role

		//let roleName = this.roles[role];

		let confirm = this.alertCtrl.create({
			title: "Rimuovere il ruolo all'utente?",
			message: "Vuoi davvero rimuovere il ruolo all'unità abitativa " + housingUnit.internal + " '" + housingUnit.label + "'?",
			buttons: [
				{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel'
				}, {
					text: UIStrings.ROLE_REMOVE,
					handler: () => {
						housingUnit[role] = false
						self.housingUnits.update(housingUnit).then((housingUnit: HousingUnit) => {
							if(housingUnit && !housingUnit[role]) {
								let toast = self.toastCtrl.create({
									message: 'Ruolo rimosso',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								})
								toast.present()
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore rimuovendo il ruolo",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							}
							self.refresh.emit(housingUnit)
						}).catch(error => {
							console.error("Errore rimuovendo il ruolo", error)
							let toast = self.toastCtrl.create({
								message: "Errore rimuovendo il ruolo",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
							self.refresh.emit(housingUnit)
						})
					}
				}
			]
		})
		confirm.present()
	}
}



// WEBPACK FOOTER //
// ./src/components/housing-unit-item/housing-unit-item.ts